import { render, staticRenderFns } from "./LienRegistrationForm.vue?vue&type=template&id=21fed720&"
import script from "./LienRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./LienRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports